import dayjs from 'dayjs'
import React from 'react'
import { useForm } from 'react-hook-form'
import { Dialog, GridHookForm } from 'vnetwork-ui'
import { hasValidEndDate } from './career-path-constants'
import type { ExtendPeriodDialogProps } from './career-path-types'

const ExtendPeriodDialog: React.FC<ExtendPeriodDialogProps> = ({
    open,
    onClose,
    currentPath,
    stages,
    isLoading,
    onSubmit,
    t,
}) => {
    const formControl = useForm({
        defaultValues: {
            new_end_date: null as any,
            extend_reason: '',
        },
    })

    React.useEffect(() => {
        if (open) {
            formControl.reset({
                new_end_date: null,
                extend_reason: '',
            })
        }
    }, [open, formControl])

    if (!currentPath) return null

    const stageLabel =
        stages.find((s) => s.value === currentPath.career_path_stage)?.label ||
        currentPath.career_path_stage
    const startDate = dayjs(currentPath.career_path_start_date).format(
        'DD/MM/YYYY'
    )
    const endDate = hasValidEndDate(currentPath.career_path_end_date)
        ? dayjs(currentPath.career_path_end_date).format('DD/MM/YYYY')
        : t('career_path.no_end_date')

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('career_path.extend_period_title')}
            closeOnClick
        >
            {/* Current stage info */}
            <div className="mb-4 rounded-lg bg-gray-50 p-3 text-sm">
                <div className="flex justify-between">
                    <span className="text-gray-500">
                        {t('career_path.stage')}
                    </span>
                    <span className="font-medium">{stageLabel}</span>
                </div>
                <div className="mt-1 flex justify-between">
                    <span className="text-gray-500">
                        {t('career_path.start_date')}
                    </span>
                    <span>{startDate}</span>
                </div>
                <div className="mt-1 flex justify-between">
                    <span className="text-gray-500">
                        {t('career_path.end_date')}
                    </span>
                    <span>{endDate}</span>
                </div>
            </div>

            <GridHookForm
                formControl={formControl}
                onSubmit={onSubmit}
                className="grid grid-cols-1 gap-4"
                data={[
                    {
                        formItemProps: {
                            name: 'new_end_date',
                            label: t('career_path.new_end_date'),
                            type: 'datepicker',
                            placeholder: t('career_path.new_end_date'),
                        },
                    },
                    {
                        formItemProps: {
                            name: 'extend_reason',
                            label: t('career_path.extend_reason'),
                            type: 'textarea',
                            placeholder: t('career_path.extend_reason'),
                        },
                    },
                ]}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'button',
                        variant: 'outline',
                        handler: onClose,
                    },
                    {
                        title: t('career_path.extend_period'),
                        type: 'submit',
                        variant: 'default',
                        loading: isLoading,
                        disabled: isLoading,
                    },
                ]}
            />
        </Dialog>
    )
}

export default ExtendPeriodDialog
